import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CONNECTOR_CATEGORIES, integrationApi, type ConnectorCatalogEntry } from '../../api/integration';

export function ConnectorMarketplacePage() {
  const [catalog, setCatalog] = useState<ConnectorCatalogEntry[]>([]);
  const [category, setCategory] = useState('');
  const [search, setSearch] = useState('');
  const [testResult, setTestResult] = useState<string | null>(null);

  useEffect(() => {
    void integrationApi.catalog(category || undefined, search || undefined).then(setCatalog);
  }, [category, search]);

  const testCatalog = async (id: string) => {
    const r = await integrationApi.testConnector({ catalog_id: id });
    setTestResult(`${id}: ${r.success ? 'OK' : 'FAIL'} (${r.latency_ms}ms)`);
  };

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Connector Marketplace</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">Browse and test marketplace, payment, logistics, government and custom connectors.</p>
      <Link to="/integrations" className="mt-2 inline-block text-sm text-teal-700 hover:underline dark:text-teal-400">← Integration Hub</Link>
      <div className="mt-4 flex flex-wrap gap-2">
        <select value={category} onChange={(e) => setCategory(e.target.value)} className="rounded border px-3 py-2 text-sm dark:border-slate-600 dark:bg-slate-800">
          <option value="">All categories</option>
          {CONNECTOR_CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
        <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search connectors…" className="rounded border px-3 py-2 text-sm dark:border-slate-600 dark:bg-slate-800" />
      </div>
      {testResult && <p className="mt-3 text-sm text-teal-700 dark:text-teal-400">{testResult}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {catalog.map((c) => (
          <div key={c.id} className="rounded-xl border p-4 dark:border-slate-700 dark:bg-slate-900">
            <div className="flex items-start justify-between">
              <div>
                <p className="font-medium">{c.name}</p>
                <p className="text-xs text-slate-500">{c.category} · {c.auth_type}</p>
              </div>
              {c.featured && <span className="rounded bg-teal-100 px-2 py-0.5 text-xs text-teal-800 dark:bg-teal-900 dark:text-teal-200">Featured</span>}
            </div>
            <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">{c.description}</p>
            <button type="button" onClick={() => testCatalog(c.id)} className="mt-3 text-sm text-teal-700 hover:underline dark:text-teal-400">Test connectivity</button>
          </div>
        ))}
      </div>
    </div>
  );
}
